export enum CustomerAgencyType {
  Default,
  BillingAgency,
}

export enum AgencyType {
  Default,
  Agency,
  Unknown,
  LeadGen = 3,
}

export enum ProductTypeEnum {
  Unknown = 0,
  BZA = 1,
  LeadGen = 2,
}

export enum regionEnum {
  China = 1,
}

export enum currencyEnum {
  USD = 1,
  CNY = 2
}

export enum deliverProductEnum {
  "none",
  "品牌专区",
  "通用词时效品专",
  "leadgen",
  "品牌直通位",
  "应用商店"
}

export enum AdCreativeTemplateTypeEnum
{
    None = 0,
    ML_Top = 1,
    ML_Sidebar= 2,
    ML = 3,
    Pole = 4,
    Mobile_Top = 5
}

export enum ExtraTemplateEnum {
  "none",
  "PC强入场浮层",
  "PC超级品专"
}
export enum MAPAccountStatusEnum {
  Valid = 1, // 有效
  Abnormal = 2, // 异常未恢复
  AbnormalTimeout = 3 // 异常超时未恢复
}

export enum AdCreativeFormStatus {
  "Unknown" = -1,
  "Deleted" = 0,
  "解析中" = 1, // 解析中
  "解析失败" = 2, // 解析失败
  "待提审" = 4, // 待提审,解析成功，
  "审核中" = 5, // 审核中
  "审核拒绝" = 6, // 审核拒绝
  "审核通过" = 7, // 审核通过
  "草稿" = 8, // 草稿
}

export enum UnitAdCreativeStatus {
  "未知" = -1,
  "待投放" = 1,
  "投放中" = 2,
  "投放暂停" = 3,
  "投放结束" = 4
}

export enum CampaignStatus {
  "未知状态" = 10,
  "未投放" = 20,
  "投放中" = 30,
  "投放暂停" = 40,
  "投放结束" = 50
}

export enum UnitPauseStatusCode {
  "未知状态" = 0,
  "未投放" = 10,
  "投放中" = 20,
  "投放暂停" = 30,
  "系统暂停" = 40,
  "投放结束" = 50
}

export enum AdCreativeUploadStatus {
  "未上传" = 0,
  "部分上传" = 1,
  "已上传" = 2
}

export enum UnitStatus {
  "未知状态" = 0,
  "未投放" = 10,
  "投放中" = 20,
  "投放暂停" = 30,
  "系统暂停" = 40,
  "投放结束" = 50
}
